import { SidebarNav } from "@atlas-int/ui";

interface SidebarProps {
  activeHeadingId: string | undefined;
  items: { id: string; label: string }[];
  onItemClick: (id: string) => void;
}

const Sidebar = ({ activeHeadingId, items, onItemClick }: SidebarProps) => {
  return (
    <SidebarNav
      activeItemId={activeHeadingId}
      items={items}
      onItemClick={onItemClick}
    />
  );
};

export default Sidebar;
